import script from "./CourseDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./CourseDescription.vue?vue&type=script&setup=true&lang=ts"

import "./CourseDescription.vue?vue&type=style&index=0&id=647f0a16&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/livoapp/LivoFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-647f0a16"]])

export default __exports__